import { Tabs, TabsList, TabsTrigger } from 'ui'
import { usePricing } from './Provider'
import { PriceRecurringInterval } from 'database'

export const PricingPeriodSwitcher = () => {
  const pricing = usePricing()

  return (
    <Tabs
      onValueChange={(value) =>
        pricing.onChangeRecurringInterval(value as PriceRecurringInterval)
      }
      defaultValue={pricing.recurringInterval}
    >
      <TabsList>
        <TabsTrigger value='month'>Mensual</TabsTrigger>
        <TabsTrigger value='year'>Anual</TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
